<template>
  <div class="container h-100">
    <div class="h-100 row align-items-center justify-content-center">
      <div class="col-10 ">
        <img
          src="@/assets/images/logos/logo-bancolombia.png"
          height="100"
          alt="Logo Bancolombia"
        />
      </div>
      <div class="col-10 mb-5">
        <p class="mt-0 mb-1 text-grey-dark text-rem-0-9">Consigna</p>
        <span class="arial-regular text-rem-2 text-dark" v-if="!user.isAgency">
          {{ settings.addThousands(selectedPlan.price) }}
        </span>
        <span class="arial-regular text-rem-2 text-dark" v-if="user.isAgency">
          {{ settings.addThousands(rechargeSelectedPlan.price) }}
        </span>
        <br />
        <p class="mb-1 mt-5 text-grey-dark text-rem-0-9">Cuenta de Ahorros</p>
        <span class="arial-regular text-rem-2 text-dark">05274764190</span>
      </div>
      <div class="col-12 col-md-8 col-lg-6 align-self-end mb-3">
        <whatsapp-Button
          v-if="!user.isAgency"
          :phone="company_data.client_service"
          :text="
            'Buenos días, he realizado un pago de ' +
              settings.addThousands(selectedPlan.price) +
              ' para el plan * ' +
              selectedPlan.type +
              '* x ' +
              selectedPlan.days +
              ' días en la ciudad de ' +
              kCity +
              ' en la categoría ' +
              kCategory +
              ' con el número de teléfono ' +
              user.username
          "
          :buttonlabel="'Enviar Comprobante'"
          :buttonClass="'bg-accent button'"
        />
        <whatsapp-Button
          v-else
          :phone="company_data.client_service"
          :text="
            'Buenos días, he realizado un pago de ' +
              settings.addThousands(rechargeSelectedPlan.price) +
              ' para el plan *' +
              selectedPlan.type +
              '* x ' +
              selectedPlan.days +
              ' días en la ciudad de ' +
              kCity +
              ' en la categoría ' +
              kCategory +
              ' con el número de teléfono ' +
              user.username
          "
          :buttonlabel="'Enviar Comprobante'"
          :buttonClass="'bg-accent button'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WhatsappButton from "@/components/UI/WhatsappButton.vue"
import settings from "@/api/settings"
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      company_data: settings.company_data,
      settings,
    }
  },
  props: ["selectedPlan", "rechargeSelectedPlan"],
  methods: {},
  computed: {
    ...mapGetters(["user", "kCity", "kCategory"]),
  },
  components: {
    WhatsappButton,
  },
}
</script>

<style lang="scss"></style>
